import type { Lot } from '../types/lot'

import { resolveLegacyLotIdentity, type LotIdentityCandidate } from './lotIdentity'

export type DashboardLotIdentityLike = {
  lotId?: LotIdentityCandidate
  canonicalLotKey?: LotIdentityCandidate
  _canonicalLotKey?: LotIdentityCandidate
  lot?: LotIdentityCandidate
  id?: LotIdentityCandidate
}

export const resolveDashboardSelectionLotKey = (lot: Pick<Lot, 'id' | 'lotKey'>): string => (
  resolveLegacyLotIdentity(
    { source: 'lotId', value: lot.id },
    { source: 'lot', value: lot.lotKey }
  ).token
)

export const resolveDashboardRowLotKey = (
  row: Pick<DashboardLotIdentityLike, 'lotId' | 'canonicalLotKey' | '_canonicalLotKey' | 'lot' | 'id'>
): string => (
  resolveLegacyLotIdentity(
    { source: 'canonicalLotKey', value: row.canonicalLotKey },
    { source: 'canonicalLotKey', value: row._canonicalLotKey },
    { source: 'lot', value: row.lot },
    { source: 'lotId', value: row.lotId },
    { source: 'rowId', value: row.id }
  ).token
)